import type React from "react"

import { clsx } from "clsx"

interface HeaderSectionProps {
  title?: React.ReactNode
  subtitle?: React.ReactNode
  headingLevel?: "h1" | "h2" | "p"
}

export const HeaderSection: React.FC<HeaderSectionProps> = ({ title, subtitle, headingLevel: Heading = "h1" }) => {
  return (
    <div className="mt-3 mb-4 w-full flex-none">
      {title && (
        <Heading className={clsx("font-manrope text-fg mb-4 text-left text-[24px] leading-tight font-bold md:text-[28px]", Heading === "p" && "text-balance")}>{title}</Heading>
      )}
      {subtitle && <p className="font-nunito text-left text-base text-gray-600">{subtitle}</p>}
    </div>
  )
}
